<template>
    <transition name="slideInLeft">
        <div class="column is-one-fifth has-background-light is-fullheight" v-if="sidebarIsOpened">
            <b-menu>
                <hr class="dropdown-divider">
                <p class="menu-label is-hidden-desktop">
                    <button class="delete is-small is-pulled-right" aria-label="close" @click="setSidebar(false)" title="Fechar o menu"></button>
                </p>
                <h4 class="title is-6 has-text-centered is-marginless">
                    {{ usuario.nome }}
                </h4>
                <p class="has-text-centered">{{ usuario.pessoa.nome }}</p>
                <hr class="dropdown-divider">
                <b-menu-list>
                    <b-menu-item icon="desktop-mac" label="Painel de Controle" tag="router-link" :to="{ name: 'painel' }"></b-menu-item>
                </b-menu-list>
                <b-menu-list label="Suporte">
                    <b-menu-item icon="face-agent" label="Atendimentos" tag="router-link" :to="{ name: 'atendimentos' }"></b-menu-item>
                    <b-menu-item icon="calendar-check" label="Tarefas" tag="router-link" :to="{ name: 'tarefas' }"></b-menu-item>
                </b-menu-list>
                <b-menu-list label="Integradores">
                    <b-menu-item icon="receipt" label="Notas Fiscais" tag="router-link" :to="{ name: 'notasfiscais' }"></b-menu-item>
                </b-menu-list>
            </b-menu>
        </div>
    </transition>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'usuario'
            ]),
            ...mapState('components', [
                'sidebarIsOpened'
            ])
        },
        methods: {
            ...mapMutations('components', [
                'handleResize',
                'setSidebar',
            ])
        }
    }
</script>